import { render } from "./PasswordConfirmation.vue?vue&type=template&id=1e0fdad8&ts=true"
import script from "./PasswordConfirmation.vue?vue&type=script&lang=ts"
export * from "./PasswordConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__